import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { ViewTreeNode } from 'src/app/engine/models/view.tree-node';
import { EngineState } from 'src/app/engine/state/engine.state';
import { BdGraphService } from 'src/lib/graph/graph.service';

@Component({
  selector: 'app-view-quiz-object-tree',
  templateUrl: './view-quiz-object-tree.component.html',
  styleUrls: ['./view-quiz-object-tree.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewQuizObjectTreeComponent implements OnInit {

  @Input()  
  public get objectIds(): string[] {
    return this._objectIds;
  }
  public set objectIds(value: string[]) {
    this._objectIds = value;
    // compute nodes
    const viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
    this.nodes = this.graphService.getNodes(viewGraph, value);
    
    this.changeRef.markForCheck();
  }
  private _objectIds: string[];

  nodes: ViewTreeNode[];

  constructor(
    private store: Store,
     private graphService: BdGraphService,
     private changeRef: ChangeDetectorRef) { }

  ngOnInit() {

  }

}
